/**
 * @generated SignedSource<<9063ac31add249c282a02bb1f7436b88>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type AnnouncementKind = "DANGER" | "INFO" | "SUCCESS" | "WARNING";
import { FragmentRefs } from "relay-runtime";
export type AnnouncementFragment$data = {
  readonly announcementByTargetPath: {
    readonly active: boolean;
    readonly badge: string | null | undefined;
    readonly expiresAt: any;
    readonly kind: AnnouncementKind;
    readonly message: string;
    readonly targetPath: string;
  } | null | undefined;
  readonly " $fragmentType": "AnnouncementFragment";
};
export type AnnouncementFragment$key = {
  readonly " $data"?: AnnouncementFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AnnouncementFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "targetPath"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "AnnouncementFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "targetPath",
          "variableName": "targetPath"
        }
      ],
      "concreteType": "Announcement",
      "kind": "LinkedField",
      "name": "announcementByTargetPath",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "targetPath",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "expiresAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "message",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "active",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "badge",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "kind",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "444815822455c2d4e030706aa10dd661";

export default node;
